import { useEffect, useState } from "react";

const KEY = "billStore";
const EVENT_NAME = "billStoreChanged";

// eslint-disable-next-line import/prefer-default-export
export const useCurrentStore = (): {
  currentStore: string | null;
  setCurrentStore: (value: string | null) => void;
} => {
  const [currentStore, setCurrentStore] = useState<string | null>(
    () => localStorage.getItem(KEY) || null
  );

  useEffect(() => {
    if (currentStore) {
      localStorage.setItem(KEY, currentStore);
    } else {
      localStorage.removeItem(KEY);
    }

    // notify same-tab listeners
    window.dispatchEvent(new Event(EVENT_NAME));
  }, [currentStore]);

  useEffect(() => {
    const sync = () => {
      setCurrentStore(localStorage.getItem(KEY) || null);
    };

    const handleStorage = (e: StorageEvent) => {
      if (e.key === KEY) {
        sync();
      }
    };

    // for same-tab sync
    window.addEventListener(EVENT_NAME, sync);

    // for cross-tab sync
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return { currentStore, setCurrentStore };
};
